import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';

import { Popover, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
    setShowConfirmationModal,
    setShowAlertFeedback
} from '../../../../../store/internal'

import { getToken } from '../../../../../store/token'

import { AppRequesterController } from '../../../../../services/appRequester/appRequesterController';
import { TokenInterfaceControlPanel } from '../../../../../services/requestsInterfacesModel';
import UserService from '../../../../../services/user-service';
import ListConfigInstagram from '.';

const AppRequesterConst = new AppRequesterController();

const ListConfigInstagramController = (props) => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [data, setData] = useState([]);

    const [showModalEdit, setShowModalEdit] = useState(false);
    const [idAccount, setIdAccount] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [pageId, setPageId] = useState('');
    const [pageName, setPageName] = useState('');
    const [userId, setUserId] = useState('');

    const funtionConfirmation = async (id: string) => {
        const headers = {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer " + values.token.value
        };

        await AppRequesterConst.Delete(
            `/channel-instagram/instagram-key/${id}`, { headers },
            (response: Object) => { },
            (data: Object) => {
                dispatch(setShowAlertFeedback({ message: "Página excluída com sucesso.", visibility: true, signalIcon: true }))
                props.getInstagramById()
            },
            (error: Object) => {
                dispatch(setShowAlertFeedback({ message: "Ocorreu um erro inesperado, tente novamente mais tarde.", visibility: true, signalIcon: false }))
            }, navigate, dispatch, setIsLoading,
        )
    }

    const deletePage = () => {
        dispatch(setShowConfirmationModal({ visibility: true, text: { "title": 'Excluir página', "body": `Tem certeza que deseja excluir a página`, "id": " " + pageName + '?', "buttonReturnText": "Cancelar", "replaceText": pageName }, functionConfirmation: () => funtionConfirmation(userId) }));
    }
    const handleOpenModalEdit = () => {
        getAccountById(userId)
    };

    const handleCloseModalEdit = () => {
        setShowModalEdit(false);
    }

    const values: TokenInterfaceControlPanel = {
        token: {
            value: useSelector(getToken)
        }
    }

    const getAccountById = async (id) => {
        const headers = {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer " + values.token.value
        };

        await AppRequesterConst.Get(
            `/channel-instagram/instagram-key/${id}`, { headers },
            (response: Object) => { },
            (data: any) => {
                if (data.status === 200) {
                    setData(data.data.instagram_key)
                    setShowModalEdit(true);
                }
            },
            (error: { response: { status: number } }) => {
                if (error.response.status === 400) {
                    dispatch(setShowAlertFeedback({ visibility: true, message: "Ocorreu um erro inesperado, tente novamente", signalIcon: false }));
                }
                if (error.response.status === 401) {

                }
            }, navigate, dispatch, setIsLoading, {}
        )
    }

    const openPopover = (pageId, id, pageName, userId) => {
        setPageId(pageId)
        setIdAccount(id)
        setPageName(pageName)
        setUserId(userId)
    }

    const popover = (
        <Popover style={{ zIndex: '500', backgroundColor: '#e6e6e6', border: 'none', color: '#40484E', font: 'var(--px15_19-font-Roboto)' }}>
            <Popover.Body className="nopadding">
                <Button onClick={handleOpenModalEdit} className="m-1" style={{ backgroundColor: 'transparent', border: 'none', color: 'black', fontSize: 'inherit' }}>Editar página</Button>


                <div>
                    <div style={{ backgroundColor: '#707070', opacity: '0.5', height: '1px', width: '100%' }}></div>
                    <Button onClick={() => deletePage()} className="m-1" style={{ backgroundColor: 'transparent', border: 'none', color: 'black', fontSize: 'inherit' }}>Excluir página</Button>
                </div>

            </Popover.Body>
        </Popover>
    );
    return <ListConfigInstagram
        props={props}
        isLoading={isLoading}
        popover={popover}
        getAccountById={getAccountById}
        data={data}
        showModalEdit={showModalEdit}
        handleCloseModalEdit={handleCloseModalEdit}
        openPopover={openPopover}
        infos={props?.datas}
        getInstagramById={props.getInstagramById}
        isEditAllowed={props.isEditAllowed}
    />

}

export default ListConfigInstagramController;